
import { useEffect } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom'; // Import the useNavigate hook
import './CandidateDashboard.css';
import DashboardBrief from './DashboardBrief'; // Assuming a dashboard brief component
import DashboardLayout from './DashboardLayout'; // Assuming you have a layout component
import GlobalCandidateSettings from './GlobalCandidateSettings';
import StatusGraph from './StatusGraph'; // Assuming a status graph component
const CandidateDashboard = () => {
  const navigate = useNavigate(); // Hook for navigation
  const location = useLocation();
  const userId = location.state?.userId;
  const userName = location.state?.userName;
  useEffect(() => {
    // Check if the hash contains the query parameters
    const hash = window.location.hash;

    // Ensure the URL contains query parameters after the hash (e.g., ?userName=john_doe)
    const urlParams = new URLSearchParams(hash.split('?')[1]);
    // Get the userName from the URL, handle empty string as null
    const userNameFromUrl = urlParams.get('userName') ? decodeURIComponent(urlParams.get('userName')) : null;
    // Get the userName from localStorage
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const userNameFromLocalStorage = userFromLocalStorage ? userFromLocalStorage.userName : null;


    // Check if userName is in the URL and matches the localStorage value
    if (userNameFromUrl !== null) {
      // If userNameFromUrl exists, compare it with the localStorage value
      if (userNameFromUrl === userNameFromLocalStorage) {
        // If they match, stay in the Candidate Dashboard

      } else {
        // If they don't match, redirect to the login page

        navigate('/signin');
      }
    } else {
      // If no userName is present in the URL
      if (userFromLocalStorage) {
        // If there's a valid user in localStorage, stay in the dashboard

      } else {
        // If no userName in the URL and no user in localStorage, redirect to login page

        navigate('/');
      }
    }
  }, [navigate]); // Re-run the effect when the navigate function changes

  const handleNavigation = () => {
    navigate('/candidate-dashboard/resume/resumeAdd', {
      state: { fileType: 'brief',userName, userId  },
    });
  };
  const handleApplyButtonClick = () => {
    navigate('/candidate-dashboard/jobs/dream-company/step/1', { state: { userName, userId } });
  };

  return (

    <DashboardLayout>
      <div className="main-content">
        <Col md={4}>
          <h2 className='text-start' style={{ paddingLeft: '12px' }}>Dashboard</h2>
        </Col>

        <DashboardBrief userId={userId} userName={userName} />


        <Row className="align-items-center" >
          <Col xs="auto">
            <div
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '12px 16px',
                backgroundColor: '#f9f9f9',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '6px',
                fontSize: '14px',
                color: '#333',
              }}
            >
              Create your Ninja profile
              <button
                onClick={handleNavigation}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  fontSize: '14px',
                }}
              >
                here
              </button>
            </div>
          </Col>

          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} />
          </Col>
        </Row>
        <Row>
          <Card
            className="card o-hidden mb-4"
            style={{
              width: '100%',
              margin: '15px 0',
              padding: '20px',
              borderLeft: '5px solid #007bff', // blue line on the left
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
              borderRadius: '8px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <p
              style={{
                fontSize: '16px',
                color: '#333',
                marginBottom: '15px',
                lineHeight: '1.5',
                maxWidth: '90%',
              }}
            >
              <strong>Dream Jobs</strong><br />
              You can apply to any company if you know the name of it here,
              and we will try connecting you with the respective HRs.
            </p>

            <Button
              onClick={handleApplyButtonClick}
              style={{
                backgroundColor: '#8e3cfaff',
                border: 'none',
                color: '#fff',
                padding: '10px 18px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: '500',
                boxShadow: '0 2px 6px rgba(0, 123, 255, 0.3)',
              }}
            >
              Apply to your Dream Company
            </Button>
          </Card>




        </Row>



        <div className="mt-4">
          <StatusGraph />
        </div>
        {/* <CircularProgressBar /> */}
      </div>

    </DashboardLayout>

  );
};

export default CandidateDashboard;



